import { AnyAction } from "redux";
import { MandateObj, SAVING_MANDATE_SUCCESS } from "../types/mandate";
import { LOGOUT_SUCCESS } from "../types/auth";


const initState: Partial<MandateObj> = {
    amount: "",
    actype: "",
    mandateType: "",
    clientCode: "",
    ifscCode: "",
    accountNo: "",
    bankName: "",
    portfolioId: "",
    startDate: "",
    endDate: ""
};
function mandateReducer(state = initState, action: AnyAction): Partial<MandateObj> {
    switch (action.type) {
        case SAVING_MANDATE_SUCCESS: {
            return {
                ...state,
                ...action.body
            }
        }
        case LOGOUT_SUCCESS: {
            return { ...initState };
        }
        default:
            return state;
    }
}

export default mandateReducer;
